import { Button, Empty, Popconfirm } from "antd";
import { useState } from "react";
import { Dialog as ZhDialog } from "zhihao-ui-react";

import type { ActivityDemandConfig } from "@/views/pages/productActivity/types";

import AddRequirementMatchDialog from "./addRequirementMatchDialog";

export interface RequirementMatchListProps {
    value?: ActivityDemandConfig[];
    onChange?: (value: ActivityDemandConfig[]) => void;
    disabled?: boolean;
}

const inputTypeLabels: Record<number, string> = {
    1: "文本框",
    2: "单选框",
    3: "多选框",
    4: "地址",
    5: "日期时间",
    6: "多行文本框"
};

/** 复刻 Vue 需求对接配置列表，并把新增/编辑弹窗作为真实受控交互接入表单。 */
export default function RequirementMatchList({ value = [], onChange, disabled = false }: RequirementMatchListProps) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [editingIndex, setEditingIndex] = useState<number | undefined>();

    return (
        <div className="activity-form__demand-editor" aria-label="需求对接配置列表">
            <div className="activity-form__demand-toolbar-row">
                <Button
                    disabled={disabled}
                    aria-label="新增需求字段"
                    type="primary"
                    onClick={() => {
                        setEditingIndex(undefined);
                        setDialogOpen(true);
                    }}
                >
                    新增
                </Button>
            </div>
            {value.length ? (
                <div className="activity-form__demand-table" role="table">
                    <div className="activity-form__demand-grid activity-form__demand-grid--header" role="row">
                        <div role="columnheader">序号</div>
                        <div role="columnheader">字段名称</div>
                        <div role="columnheader">是否必填</div>
                        <div role="columnheader">输入类型</div>
                        <div role="columnheader">操作</div>
                    </div>
                    {value.map((item, index) => (
                        <div
                            className="activity-form__demand-grid"
                            key={`${item.fieldName || "field"}-${index}`}
                            role="row"
                        >
                            <div role="cell">{index + 1}</div>
                            <div role="cell">{item.fieldName || "-"}</div>
                            <div role="cell">{Number(item.hasRequired) === 1 ? "是" : "否"}</div>
                            <div role="cell">{inputTypeLabels[Number(item.inputType) || 1]}</div>
                            <div className="activity-form__demand-actions" role="cell">
                                <Button
                                    disabled={disabled}
                                    type="link"
                                    onClick={() => {
                                        setEditingIndex(index);
                                        setDialogOpen(true);
                                    }}
                                >
                                    编辑
                                </Button>
                                <Popconfirm
                                    disabled={disabled}
                                    title="确定删除此需求字段吗？"
                                    onConfirm={() =>
                                        onChange?.(value.filter((_item, itemIndex) => itemIndex !== index))
                                    }
                                >
                                    <Button disabled={disabled} type="link" danger>
                                        删除
                                    </Button>
                                </Popconfirm>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="activity-form__demand-empty">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无数据" />
                </div>
            )}
            <ZhDialog
                open={dialogOpen}
                title={editingIndex == null ? "新增字段" : "编辑字段"}
                width="640px"
                onCancel={() => setDialogOpen(false)}
                footer={null}
            >
                <AddRequirementMatchDialog
                    initialValue={editingIndex == null ? undefined : value[editingIndex]}
                    onCancel={() => setDialogOpen(false)}
                    onSubmit={item => {
                        const next = [...value];
                        if (editingIndex == null) next.push(item);
                        else next[editingIndex] = item;
                        onChange?.(next);
                        setDialogOpen(false);
                    }}
                />
            </ZhDialog>
        </div>
    );
}
